import React, { useCallback, useEffect, useState } from 'react';
import Login from './components/Login';
import { useImmer } from 'use-immer';
import axios from './utils/Axios';
import socket from './utils/SocketIo';
import CallCenter from './components/CallCenter';
import useTokenFromLocalStorage from './hooks/useTokenFromLocalStorage';
import { Device } from '@twilio/voice-sdk';

// Accepts 949..., (949) 555-1212, 1-949..., or +1 949...
function normalizePhone(input) {
  if (!input) return '';
  const raw = String(input).trim();
  const digits = raw.replace(/\D/g, '');

  // If they already typed +E.164, accept if it looks real (>=10 digits)
  if (raw.startsWith('+')) return digits.length >= 10 ? '+' + digits : '';

  // US/NANP normalization
  if (digits.length === 10) return '+1' + digits;                 // 949xxxxxxx -> +1949...
  if (digits.length === 11 && digits.startsWith('1')) return '+1' + digits.slice(1); // 1-949... -> +1949...

  // Anything else = invalid for our flow
  return '';
}


function App() {
  const [calls, setCalls] = useImmer({
    calls: [],
  });

  function handleLogout() {
  // 1) Drop the token your hook tracks → this flips isValidToken to false
  try { setStoredToken(null); } catch (e) {}

  // 2) Belt & suspenders: remove any token we might have saved elsewhere
  try { sessionStorage.removeItem('jwt'); localStorage.removeItem('jwt'); } catch (e) {}

  // 3) Stop the socket
  try { if (socket.client && socket.client.disconnect) socket.client.disconnect(); } catch (e) {}
  try { socket.removeToken(); } catch (e) {}

  // 4) (Optional) if your Axios instance adds Authorization, clear it
  try { axios.defaults.headers.common['Authorization'] = undefined; } catch (e) {}

  // 5) (Optional) visual confirmation during testing
  // alert('Logged out');
  // 6) Reload to a clean slate (use replace so back button can’t return to the authed view)
  window.location.replace(window.location.origin + '/');
  // If you prefer a plain refresh on the same URL, use:
  // window.location.reload();


}


  const [user, setUser] = useImmer({
    username: '',
    mobileNumber: '',
    verificationCode: '',
    verificationSent: false,
  });

  const onCallNew = useCallback(({ data: { CallSid, CallStatus } }) => {
  setCalls(draft => {
    const i = draft.calls.findIndex(c => c.CallSid === CallSid);
    if (i === -1) draft.calls.push({ CallSid, CallStatus });
  });
}, [setCalls]);

  const [twilioToken, setTwilioToken] = useState();

  const [storedToken, setStoredToken, isValidToken] = useTokenFromLocalStorage(
    null
  );

  useEffect(() => {
    console.log('Twilio token changed');
    if (twilioToken) {
      connectTwilioVoiceClient(twilioToken);
    }
  }, [twilioToken]);

  useEffect(() => {

      // body classes (mask)
  document.body.classList.toggle('loggedIn',  !!isValidToken);
  document.body.classList.toggle('loggedOut', !isValidToken);

  if (isValidToken) {
    // boot socket with token
    return socket.addToken(storedToken);
  }

  // logged out: nuke socket + state
  try { if (socket.client && socket.client.connected) socket.client.disconnect(); } catch {}
  socket.removeToken();
  setTwilioToken(undefined);

/*
    if (isValidToken) {
      console.log('Valid token');
      document.body.classList.toggle('loggedIn',  !!isValidToken);
    document.body.classList.toggle('loggedOut', !isValidToken);

      return socket.addToken(storedToken);
    }
    console.log('invalid token');
    socket.removeToken();*/
  }, [isValidToken, storedToken]);

  useEffect(() => {
    socket.client.on('connect', () => {
      console.log('Connected');
    });
    socket.client.on('disconnect', () => {
      console.log('Socket disconnected');
    });
    socket.client.on('twilio-token', (data) => {
      console.log('Receive Token from the backend');
      setTwilioToken(data.token);
    });

    socket.client.on('call-new', ({ data: { CallSid, CallStatus } }) => {
      console.log('New Call');

      setCalls((draft) => {
        const index = draft.calls.findIndex(call => call.CallSid === CallSid);
        if (index === -1) {
          draft.calls.push({ CallSid, CallStatus });
        }
      });
    });

    socket.client.on('enqueue', ({ data: { CallSid } }) => {
      setCalls((draft) => {
        const index = draft.calls.findIndex(
          ({ CallSid }) => CallSid === CallSid
        );
        if (index === -1) {
          return;
        }
        draft.calls[index].CallStatus = 'enqueue';
      });
    });
    return () => {};
  }, [socket.client]);

  async function sendSmsCode() {
  console.log('Sending SMS');
  const norm = normalizePhone(user.mobileNumber);
  if (!norm) { alert('Enter a valid US phone number'); return; }

  await axios.post('/login', {
    to: norm,
    username: user.username,
    channel: 'sms',
  });

  setUser(draft => {
    draft.mobileNumber = norm;       // keep normalized going forward
    draft.verificationSent = true;
  });
}



  /*

  async function sendSmsCode() {
    console.log('Sending SMS');
    await axios.post('/login', {
      to: user.mobileNumber,
      username: user.username,
      channel: 'sms',
    });
    setUser((draft) => {
      draft.verificationSent = true;
    });
  }*/

  function connectTwilioVoiceClient(twilioToken) {
    const device = new Device(twilioToken, { debug: true });
    device.on('error', (error) => {
      console.error(error);
    });
    device.on('incoming', (connection) => {
      console.log('Incoming from twilio');
      connection.accept();
    });
  }

  async function sendVerificationCode() {
  console.log('Sending verification');
  const norm = normalizePhone(user.mobileNumber);  // already normalized, but safe
  if (!norm) { alert('Phone number missing/invalid'); return; }

  const response = await axios.post('/verify', {
    to: norm,
    code: user.verificationCode,
    username: user.username,
  });
  console.log('received token', response.data.token);
  setStoredToken(response.data.token);
  window.unmaskPortal?.();
}


  /*
  async function sendVerificationCode() {
    console.log('Sending verification');
    const response = await axios.post('/verify', {
      to: user.mobileNumber,
      code: user.verificationCode,
      username: user.username,
    });
    console.log('received token', response.data.token);
    setStoredToken(response.data.token);
    window.unmaskPortal?.();

  }*/

  return (
  <div>
    {isValidToken ? (
      <>
        <button onClick={handleLogout}>Logout</button>
        <CallCenter calls={calls} />
      </>
    ) : (
      <Login
        user={user}
        setUser={setUser}
        sendSmsCode={sendSmsCode}
        sendVerificationCode={sendVerificationCode}
      />
    )}
  </div>
  );
}//<CallCenter calls={calls} />

export default App;
